<template>
  <v-container fluid>
    <aade-book :invoices="invoices" :loading="loading"></aade-book>
  </v-container>
</template>

<script>

import AadeBook from '../../components/AadeBook.vue';

export default {
  components: {
    AadeBook
  },
  computed: {
      dateRangeText () {
        return this.filter_dates.join(' ~ ')
      },
  },
  data() {
    return {
      loading: true,
      search: '',
      invoices: [],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/aade/purchases');
        console.log(response);
        this.invoices = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  checkDates (date) {
    let d = new Date(date).getTime();
    let f = new Date(this.filter_dates[0]).getTime();
    let t = new Date(this.filter_dates[1]).getTime();
    console.log(d, f, t)
    if (d >= f && d <= t) return true;
    return false;
  },
  functionEvents (date) {
    return this.invoices.some(e => e.DocDate == date);
  },
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  sumField(items, key) {
    // sum data in give key (property)
    return items.reduce((a, b) => a + (b[key] || 0), 0);
  },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },
  }
}
</script>
